import React, { Component } from 'react';
import { base, firebaseAuth } from '../../../../config/constants.js'
import { Icon, Divider, Grid, Button } from 'semantic-ui-react';
import { checkAdminEmail } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import WhatsAppSingleChatView from './WhatsAppSingleChatView'
import WhatsappSetPhoneUi from './WhatsappSetPhoneUi'
import WhatsappConvUi from './WhatsappConvUi'


class WhatsappChatView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageList: [],
            newConvList: [],
            phone: ''
        }
    }

    componentDidMount() {

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user,
                    })

                    //GET MESSAGES
                    this.fetchMessages();
                    this.fetchConversations();

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");

                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })


    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    // base.syncState('whatsapp/' + this.props.phone + "/messages", {
    //     context: this,
    //     state: 'messages',
    //     asArray: true,
    //     queries: {
    //         orderByChild: 'createdDateSeconds',
    //     },
    //     then() {
    //         //console.log("whtx2 messsages:"+JSON.stringify(data,null,3))
    //         // this.setState({ loading: false });
    //         // this.countSupplies();

    //     }
    // });

    fetchMessages = () => {
        base.syncState('whatsapp', {
            context: this,
            state: 'messageList',
            asArray: true,
            queries: {
                orderByChild: 'createdDateSeconds',
            },
            then() {
            }
        });
    }

    fetchConversations = () => {
        base.syncState('whatsapp/latestmessages', {
            context: this,
            state: 'newConvList',
            asArray: true,
            queries: {
                orderByChild: 'createdDateSeconds',
                //equalTo: 'no'
            },
            then() {


            }
        });

        // base.fetch('whatsapp/latestmessages', {
        //     context: this,
        //     state: 'newConvList',
        //     asArray: true,
        //     queries: {
        //         orderByChild: 'createdDateSeconds',
        //     },
        //     then(data) {
        //         console.log("nxxx:"+JSON.stringify(data,null,3))

        //     }
        // });
    }

    // fetchMessages = () => {
    //     base.syncState('whatsapp', {
    //         context: this,
    //         asArray: true,
    //         // queries: {
    //         //     orderByChild: 'order_num',
    //         //     equalTo: parseInt(orderNum)
    //         // },
    //         then(data) {

    //             console.log("whtx data:" + JSON.stringify(data, null, 3));


    //             this.setState({
    //                 messageList: data
    //             })
    //         }
    //     });
    // }

    setPhone = (phone) => {
        console.log("whtx2 MAIN ONE ++ setPhone:" + phone);
        this.setState({
            phone: phone
        })
    }

    render() {

        const newConvListItem = this.state.newConvList.length > 0
            ? this.state.newConvList.map((message) =>

                // <List.Item>{message.key}</List.Item>
                // <Button on>{message.key}</Button>
                <div>
                    <WhatsappConvUi key={message.key} setPhoneFunction={this.setPhone} message={message} />
                    <br />
                </div>

            )
            : ''


        const convListItem = this.state.messageList.length > 0
            ? this.state.messageList.map((message) =>

                <div>
                    <WhatsappSetPhoneUi setPhoneFunction={this.setPhone} message={message} />
                    <br />
                </div>

            )
            : ''


        const convList = this.state.messageList.length > 0
            ?
            <div>{convListItem}</div>
            : ''

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : <h3>NO USER FOUND</h3>

        const mainGrid = this.state.user && this.state.user.email
            ? <Grid divided='vertically'>
                <Grid.Row columns={3}>
                    <Grid.Column width={2}>
                        <h1>{this.state.messageList.length} convs</h1>
                        {convList}
                        <br />
                    </Grid.Column>
                   
                    <Grid.Column width={3}>
                    <Divider>{this.state.newConvList.length}- {'Unread Messages'}</Divider>
                        {newConvListItem}
                    </Grid.Column>

                    <Grid.Column width={9}>
                        <h1>Chats</h1>
                        <WhatsAppSingleChatView phone={this.state.phone} user={this.state.user} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            : <h3>NO USER FOUND</h3>

        return (<div>
            <h1>WhatsappChatView {userEmail} - {this.state.messageList.length}</h1>

            {mainGrid}


        </div>);
    }
}

export default WhatsappChatView;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappChatView.js